/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Section_3_P2Inputs */

const en_terms_section_3_p2 = /** @type {(inputs: Terms_Section_3_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The scope, deliverables, timeline and price of any piece of work are set out in a separate agreement between Lindevo and the client. These terms govern general use of the website and set the frame around that agreement.`)
};

const lv_terms_section_3_p2 = /** @type {(inputs: Terms_Section_3_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Katra darba apjoms, rezultāti, termiņi un cena tiek noteikti atsevišķā vienošanās dokumentā starp Lindevo un klientu. Šie noteikumi attiecas uz tīmekļvietnes lietošanu un nosaka šīs vienošanās vispārējo ietvaru.`)
};

/**
* | output |
* | --- |
* | "The scope, deliverables, timeline and price of any piece of work are set out in a separate agreement between Lindevo and the client. These terms govern gener..." |
*
* @param {Terms_Section_3_P2Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const terms_section_3_p2 = /** @type {((inputs?: Terms_Section_3_P2Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Section_3_P2Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_terms_section_3_p2(inputs)
	return en_terms_section_3_p2(inputs)
});